import { isGetUserFinished } from '../getUser';

export class UserSession {
    private static sessionInstance: UserSession;

    // eslint-disable-next-line no-useless-constructor,no-empty-function
    private constructor() {}


    public async isNewProgress(): Promise<boolean> {
        await isGetUserFinished();
        return window.app.getGameStartDataResponse?.registration === 1;
    }

    public logout(): void {
        location.href = `${window.app.config.game_site_url}/logout`;
    }

    public static getInstance(): UserSession {
        if (typeof UserSession.sessionInstance === 'undefined') {
            UserSession.sessionInstance = new UserSession();
        }

        return UserSession.sessionInstance;
    }

    public getDeviceId(): string {
        return window.app.deviceIdentifier;
    }
}
